import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IPaymentRequisitionData, IUserData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { IPaymentRequisitionState } from './paymentrequisition.types';

export const state: IPaymentRequisitionState = {
  version: 1,
  paymentRequisitions: [] as IPaymentRequisitionData[],
  lastCreatedPaymentRequisitionId: null as null | number,
  lastCreatedPaymentRequisitionCommentId: null as null | number,
  count: 0,
  approvers: [] as IUserData[],
  apSpecialists: [] as IUserData[],
  activities: [],
  comments: [],
  mentionableUsers: [] as IUserData[],
  lastPromise: null
};

const namespaced = true;

export const paymentRequisition: Module<
  IPaymentRequisitionState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
